import { createStorefrontClient } from '@template-project/storefront-bff-client';
import type { CustomerSubscription, SubscriptionItemUpdate } from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

function getClient() {
  return createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
  });
}

export async function getCustomerSubscriptions(customerId: string): Promise<CustomerSubscription[]> {
  const res = await getClient().getCustomerSubscriptions(customerId);
  return res.data ?? [];
}

export async function cancelSubscription(
  customerId: string,
  subscriptionId: string,
  reason: string,
): Promise<void> {
  return getClient().cancelSubscription(customerId, subscriptionId, { reason });
}

export async function pauseSubscription(
  customerId: string,
  subscriptionId: string,
  reason?: string,
): Promise<void> {
  return getClient().pauseSubscription(customerId, subscriptionId, { reason });
}

export async function resumeSubscription(
  customerId: string,
  subscriptionId: string,
): Promise<void> {
  return getClient().resumeSubscription(customerId, subscriptionId);
}

export async function skipSubscription(
  customerId: string,
  subscriptionId: string,
  reason?: string,
): Promise<void> {
  return getClient().skipSubscription(customerId, subscriptionId, { reason });
}

export async function rescheduleSubscription(
  customerId: string,
  subscriptionId: string,
  newNextChargeDate: string,
): Promise<void> {
  return getClient().rescheduleSubscription(customerId, subscriptionId, {
    new_next_charge_date: newNextChargeDate,
  });
}

export async function updateSubscriptionItems(
  customerId: string,
  subscriptionId: string,
  items: SubscriptionItemUpdate[],
): Promise<CustomerSubscription> {
  const res = await getClient().updateSubscriptionItems(customerId, subscriptionId, { items });
  return res.data;
}
